import { useEffect, useState } from 'react';

/**
 * This hook integrates GetSiteControl into our application.
 *
 * For further information about GetSiteControl, visit the following pages:
 * @see {@link https://getsitecontrol.com/help/install-widgets-website|Installing widgets on your website}
 * @see {@link https://getsitecontrol.com/help/javascript-api/#targeting|GetSiteControl JavaScript API}
 */

const useGetSiteControlScript = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    // The first script adds GetSiteControl to our application
    const script = document.createElement('script');
    script.src = '//l.getsitecontrol.com/z4qx1zgw.js';
    script.async = true;
    script.type = 'text/javascript';
    script.setAttribute('id', 'getsitecontrol');
    script.onload = () => setScriptLoaded(true);

    // The second script gives GetSiteControl global access to our application
    const gscScript = document.createElement('script');
    gscScript.innerHTML = `
      window.gsc =
        window.gsc ||
        function () {
          (gsc.q = gsc.q || []).push(arguments);
        };
    `;

    // Add the script only if doesn't already exist
    // This is needed to avoid multiple script injection
    if (!document.querySelector(`script[id="getsitecontrol"]`)) {
      document.body.appendChild(script);
    }

    if (!document.querySelector('script[data-gsc="true"]')) {
      gscScript.setAttribute('data-gsc', 'true');
      document.body.appendChild(gscScript);
    }
  }, []);

  return scriptLoaded;
};

export default useGetSiteControlScript;
